import React, { PureComponent, Fragment } from 'react';
import { withRouter } from "react-router-dom";
import PropTypes from 'prop-types';
import { Progress, Table, Badge } from 'reactstrap';
import Panel from '../../../../shared/components/Panel';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import searchActions from '../../../../redux/actions/searchActions';
import TrendDownIcon from 'mdi-react/TrendingDownIcon';
import TrendUpIcon from 'mdi-react/TrendingUpIcon';
import { 
	_capitalizeText,
	_formatNumber,
	_formatPrice,
	_formatBed,
	_nameToUrl,
	_scrollTo
} from "../../../../shared/helpers/utils";

function matchDates(data, selectedDate, mode = 'monthly') {
  const selectedDateOnly = selectedDate ? selectedDate.split('T')[0]: null;

  // Helper function to strip time from ISO date
  const stripTime = (isoDate) => isoDate.split('T')[0];

  // Initialize result object
  const result = {
	matching: null,
	previous: null,
	yearOverYear: null
  };

  data.forEach((item, index) => {
	const itemDateOnly = stripTime(item.val);

	if (itemDateOnly === selectedDateOnly) {
	  result.matching = { index, ...item };
	}

	if (mode === 'monthly') {
	  const selectedYear = parseInt(selectedDateOnly.split('-')[0], 10);
	  const selectedMonth = parseInt(selectedDateOnly.split('-')[1], 10);

	  const itemYear = parseInt(itemDateOnly.split('-')[0], 10);
	  const itemMonth = parseInt(itemDateOnly.split('-')[1], 10);

	  const isPreviousMonth = 
		(itemYear === selectedYear && itemMonth === selectedMonth - 1) ||
		(itemYear === selectedYear - 1 && selectedMonth === 1 && itemMonth === 12);

	  const isPreviousYearMonth = 
		itemYear === selectedYear - 1 && itemMonth === selectedMonth;

	  if (isPreviousMonth) {
		result.previous = { index, ...item };
	  }

	  if (isPreviousYearMonth) {
		result.yearOverYear = { index, ...item };
	  }
	} else if (mode === 'weekly') {
	  const selectedDateObj = new Date(selectedDateOnly);
	  const selectedWeekStart = new Date(selectedDateObj);
	  selectedWeekStart.setDate(selectedDateObj.getDate() - selectedDateObj.getDay());

	  const previousWeekStart = new Date(selectedWeekStart);
	  previousWeekStart.setDate(selectedWeekStart.getDate() - 7);

	  const previousWeekEnd = new Date(previousWeekStart);
	  previousWeekEnd.setDate(previousWeekStart.getDate() + 6);

	  const yearOverYearWeekStart = new Date(selectedWeekStart);
	  yearOverYearWeekStart.setFullYear(selectedWeekStart.getFullYear() - 1);

	  const yearOverYearWeekEnd = new Date(yearOverYearWeekStart);
	  yearOverYearWeekEnd.setDate(yearOverYearWeekStart.getDate() + 6);

	  const itemDateObj = new Date(itemDateOnly);

	  const isPreviousWeek = 
		itemDateObj >= previousWeekStart &&
		itemDateObj <= previousWeekEnd;

	  const isYearOverYearWeek = 
		itemDateObj >= yearOverYearWeekStart &&
		itemDateObj <= yearOverYearWeekEnd;

	  if (isPreviousWeek) {
		result.previous = { index, ...item };
	  }

	  if (isYearOverYearWeek) {
		result.yearOverYear = { index, ...item };
	  }
	}
  });

  return result;
}




const reformatInventoryData = (data) => {
	const bedroomCategories = [
		{ key: "studio", val: "Studio" },
		{ key: "1_bed", val: "1 Bed" },
		{ key: "2_bed", val: "2 Beds" },
		{ key: "3_bed", val: "3 Beds" },
		{ key: "4_plus_bed", val: "4+ Beds" },
		{ key: "unknown_bed", val: "Unknown" },
	];

	return bedroomCategories.map(({ key, val }) => ({
		val,
		sum_inventory_unsold: data[`sum_inventory_unsold_${key}`] || 0,
	}));
}
class TradeHistory extends PureComponent {
  static propTypes = {
   	t: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
  
  }
  
  handleClick(e,unit) {
  	console.log(e, e.target);

  	const { history, name, itemKey, toggle, setFilter } = this.props;
  	const { addTag } = this.props.actions; 
  	let qString = '';
  	if(itemKey === 'by_bedrooms'){
	  	
	  	if(unit.val === 0){
		  	qString='studio';
	  	}else if(unit.val === 1){
		  	qString=`${unit.val}-bedroom`;
	  	}else if(unit.val < 4){
		  	qString=`${unit.val}-bedroom`;
	  	}else{
		  	qString=`4-or-more`;
	  	}
	  	setFilter("offering_bedrooms", qString);
	  	toggle('buildings');
	  	_scrollTo();
	  	
  	}else if(itemKey === 'by_boroughs'){
	  	const id = _nameToUrl(unit.val);
	  	addTag({type:'borough', data: unit.val, id: id, name: unit.val});
	  	toggle('buildings');
	  	_scrollTo();
	  	//history.push(`/analysis/discount/tab/buildings`);
  	}else if(itemKey === 'by_neighborhoods'){
	  	const hood = unit.val;
	  	const boro = unit.by_borough && unit.by_borough.buckets && unit.by_borough.buckets[0] ? unit.by_borough.buckets[0].val : '';
	  	const obj = {
		  	hood: hood,
		  	boro: boro
	  	}
	  const id = _nameToUrl(obj.hood + obj.boro);
	  addTag({type:'neighborhood', data: obj, id: id, name: obj.hood});
	  toggle('buildings');
	  _scrollTo();
	  //history.push(`/analysis/discount/tab/buildings`);
  	}
  	

  }



 render() {
	 
	 const { t, stats, name, itemKey, col, selectedDate } = this.props;
	 let statData = stats && stats.by_time && stats.by_time.buckets ? stats.by_time.buckets : []
	
	 
	 const matchedData = matchDates(statData, selectedDate);
	 console.log(matchedData);
	 if(!matchedData) return null;
	 
	 let filterData = matchedData.matching.by_boroughs.buckets;
	 filterData.push({val:"All NYC", sum_inventory_unsold: matchedData.matching.sum_inventory_unsold});
	 let previousData = matchedData.previous.by_boroughs.buckets;
	 previousData.push({val:"All NYC", sum_inventory_unsold: matchedData.previous.sum_inventory_unsold});
	 let previousYearData = matchedData.yearOverYear.by_boroughs.buckets;
	 previousYearData.push({val:"All NYC", sum_inventory_unsold: matchedData.yearOverYear.sum_inventory_unsold});
	 if(itemKey==='by_bedrooms'){
		 filterData = reformatInventoryData(matchedData.matching);
		 previousData = reformatInventoryData(matchedData.previous);
		 previousYearData = reformatInventoryData(matchedData.yearOverYear);
	 }
	 return (
			  <Panel
			    xl={col ? col : 4}
			    lg={col ? col : 6}
			    md={12}
			    xs={12}
			    title={`Inventory By ${name}`}
			    noButtons
			  >
			    <Table responsive striped className="table--bordered dashboard__audience-table">
			      <thead>
			        <tr>
			          <th>{name}</th>
			          <th>Inventory</th>
			          <th>MoM Change</th>
					  <th>YoY Change</th>
			        </tr>
			      </thead>
			      <tbody>
			      { filterData.filter(item => !(item.val==="" || item.val === -1)).map((item, index) => {
					         
					      let prev = previousData.filter(p => p.val == item.val)[0];
						  let prevYear = previousYearData.filter(p => p.val == item.val)[0];
						  let prevChg = ((item.sum_inventory_unsold - prev.sum_inventory_unsold) / prev.sum_inventory_unsold) * 100;
						  let prevYearChg = ((item.sum_inventory_unsold - prevYear.sum_inventory_unsold) / prevYear.sum_inventory_unsold) * 100;
					      return (
						      	<tr onClick={(e) => this.handleClick(e, item)} className="tr__link">
						      	  {/* <td>
						      	  	<Badge color="matching" style={{ width:50, minWidth:50, color:'#B070CC', border:'1px solid #B070CC', background:'#FFF', padding: "6px 0" }}>
								  		<span className="bold-text">{index+1}</span>
								  	</Badge>
								  </td>							   */}
						          <td>
						          		<Badge color="matching" style={{ width:100, minWidth:50, color:'#B070CC', border:'1px solid #B070CC', background:'#FFF', padding: "6px 0" }}>
										  <span className="bold-text">{_capitalizeText(item.val.toString())}</span>
						          			
						          		</Badge>
								  		
						          </td>
						          <td>
							          	{_formatNumber(item.sum_inventory_unsold)} Units
						          </td>
						          <td>
											<Fragment>                      
												  {prevChg < 0 ? 
														  <TrendDownIcon  size={18} style={{ marginTop:"-3px", marginRight:"5px"}} color={'#FF206E'} /> 
														  : <TrendUpIcon  size={18} style={{ marginTop:"-3px", marginRight:"5px"}} color={'#4ce1b6'}/>
													  } 			                          
												<span className="small-text">{(prevChg).toFixed(2)} %</span>
											  </Fragment> 
								  </td>
								  <td>
										<Fragment>                      
											  {prevYearChg < 0 ? 
													  <TrendDownIcon  size={18} style={{ marginTop:"-3px", marginRight:"5px"}} color={'#FF206E'} /> 
													  : <TrendUpIcon  size={18} style={{ marginTop:"-3px", marginRight:"5px"}} color={'#4ce1b6'}/>
												  } 			                          
											<span className="small-text">{(prevYearChg).toFixed(2)} %</span>
										  </Fragment> 
								  </td>
						        </tr>
					      )
				      })
				      
			      }   
			      </tbody>
			    </Table>
			  </Panel>
		)
	}
};

function mapStateToProps(state) {
  return { searchTags: Array.isArray(state.search.searchTags) ? state.search.searchTags.slice() : []};
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(searchActions, dispatch) };
}


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TradeHistory));
